import React from 'react';
import { Link } from 'react-router-dom';
import './ConsultingHero.css';

// We can reuse a decorative graphic you already have
import graphicImg from '../../assets/images/stats-hero-graphic.png';

const ConsultingHero = () => {
  return (
    <section className="consulting-hero-section">
      <div className="consulting-hero-content">
        <h1>Consulting</h1>
        <p>
          A strategy lab for businesses navigating crop and commodity markets where demand and growth planning is grounded in real market dynamics.
        </p>
        <Link to="/signup">
          <button className="book-demo-btn">Book a demo</button>
        </Link>
      </div>
      <div className="consulting-hero-graphic">
        <img src={graphicImg} alt="Consulting and Data Graphic" />
      </div>
    </section>
  );
};

export default ConsultingHero;